import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { outcomeStyle } from '../../../core/models/outcome-style.model';
import { OutcomeKind } from '../../../core/models/interaction.model';
import { COME_BACK_LATER_OBJECTION_ID } from '../../../core/models/objection.model';
import { ChipComponent } from '../chip/chip.component';
import { IconComponent } from '../icon/icon.component';
import { TranslatePipe } from '../../pipes/translate.pipe';

/**
 * Renders an outcome kind as a coloured chip with icon + translated label.
 * Colour is paired with an icon so the meaning survives colourblindness and
 * sunlight. The colour/icon map lives in outcome-style.model.ts, shared with
 * the map's building-fill layer — see that file's doc comment.
 */
@Component({
  selector: 'app-outcome-chip',
  standalone: true,
  imports: [ChipComponent, IconComponent, TranslatePipe],
  templateUrl: './outcome-chip.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './outcome-chip.component.css',
})
export class OutcomeChipComponent {
  outcome = input.required<OutcomeKind | string>();
  /** Pass the interaction's objection_id when known, so "come back later" gets its own look. */
  objectionId = input<string>('');

  style = computed(() => outcomeStyle(this.outcome(), this.objectionId()));

  labelKey = computed(() =>
    this.outcome() === 'objection' && this.objectionId() === COME_BACK_LATER_OBJECTION_ID
      ? 'outcomes.objectionComeBackLater'
      : `outcomes.${this.outcome()}`,
  );
}
